import Vue from 'vue'
import VueGmaps from 'vue-gmaps'


Vue.use(VueGmaps, {
  key: process.env.GOOGLE_MAPS_API_KEY,
  loadGoogleApi: false
})
